import _ from 'lodash'
import { APP_SETTINGS } from '@/common/config'
import axiosIns from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'
import SystemHelper from '@/common/systemHelper'

export const GET_INTRODUCER_TRANSACTION_PAYMENT_RECORD = 'getIntroducerTransactionRecord'
export const SET_INTRODUCER_TRANSACTION_PAYMENT_RECORD = 'setIntroducerTransactionRecord'

export default {
  namespaced: true,
  state: {
    introducerTransactionPaymentRecord: null,
  },
  getters: {
    getRawData: state => key => {
      const data = state[key]
      if (data) {
        return data.list
      } return {}
    },
    getPaginationInfo: state => {
      const list = state.introducerTransactionPaymentRecord
      if (list) {
        return list
      }
      return []
    },
    getPaymentRecord: state => {
      const currentState = state.introducerTransactionPaymentRecord
      if (currentState) {
        const list = currentState.list.data
        if (Array.isArray(list) && list.length) {
          return list
        }
        return []
      }
      return []
    },
  },
  mutations: {
    [SET_INTRODUCER_TRANSACTION_PAYMENT_RECORD](state, val) {
      state.introducerTransactionPaymentRecord = val
    },
  },
  actions: {
    // account-introducer/introducer-record-data
    [GET_INTRODUCER_TRANSACTION_PAYMENT_RECORD](context, payload) {
      return new Promise((resolve, reject) => {
        /// api/v1/account-introducer/introducer-payment-record-data
        const endpoint = `account-introducer/introducer-payment-record-data?skip=${payload.skip}&limit=${payload.limit}`

        axiosIns.post(`${APP_SETTINGS.BASE_URL + APP_SETTINGS.API_VERSION_NUM}${endpoint}`, payload)
          .then(res => {
            if (res.data.response_code === 2000) {
              useJwt.setToken(res.data.token)

              context.commit(SET_INTRODUCER_TRANSACTION_PAYMENT_RECORD, res.data.data)

              SystemHelper.successHandler(res)
              resolve(res)
            } else {
              SystemHelper.errorHandler(res)
              resolve(res)
            }
          })
          .catch(err => {
            SystemHelper.handleCatch()
            reject(err)
          })
      })
    },
  },
}
